/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_ColourInputs */

const en_col_colour = /** @type {(inputs: Col_ColourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colour`)
};

/**
* | output |
* | --- |
* | "Colour" |
*
* @param {Col_ColourInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const col_colour = /** @type {((inputs?: Col_ColourInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_ColourInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_col_colour(inputs)
});